import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AnalyticsConsentPreference, AnalyticsService } from 'src/app/services/analytics.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-consent-manager',
  templateUrl: './consent-manager.component.html',
  styleUrls: ['./consent-manager.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class ConsentManagerComponent implements OnInit {
  isVisible = false;
  view: 'prompt' | 'settings' = 'prompt';
  analyticsEnabled = false;
  adsEnabled = false;

  readonly cookiePolicyUrl = 'https://altomate.io/cookiespolicy/';
  readonly privacyPolicyUrl = 'https://altomate.io/privacy-policy/';

  constructor(
    private analyticsService: AnalyticsService,
    protected generalService: GeneralService,
  ) { }

  ngOnInit(): void {
    const savedPreference = this.analyticsService.getStoredConsentPreference(this.generalService.isNativePlatform());

    if (savedPreference) {
      this.analyticsEnabled = savedPreference.analytics === 'granted';
      this.adsEnabled = savedPreference.ads === 'granted';
      this.analyticsService.applyConsentPreference(savedPreference);
      return;
    }

    this.isVisible = true;
  }

  async acceptAll(): Promise<void> {
    await this.saveConsentPreference({ analytics: 'granted', ads: 'granted' });
  }

  async necessaryOnly(): Promise<void> {
    await this.saveConsentPreference({ analytics: 'denied', ads: 'denied' });
  }

  async savePreferences(): Promise<void> {
    await this.saveConsentPreference({
      analytics: this.analyticsEnabled ? 'granted' : 'denied',
      ads: this.adsEnabled ? 'granted' : 'denied',
    });
  }

  openSettings(): void {
    this.view = 'settings';
  }

  backToPrompt(): void {
    this.view = 'prompt';
  }

  openUrl(url: string): void {
    window.open(url, '_blank');
  }

  private async saveConsentPreference(preference: AnalyticsConsentPreference): Promise<void> {
    await this.analyticsService.saveAndApplyPlatformConsentPreference(
      preference,
      this.generalService.isNativePlatform(),
    );
    this.isVisible = false;
  }
}
